import { Outlet } from "react-router-dom"

export const Settings = () => {
  return (
    <Outlet />
  )
}
